import React, { Fragment } from "react"
import { appPlayerProfilePath } from "../../paths"
import { TeamRound } from "../../types"
import { formatScore, thru } from "../../util"

interface IndividualLeaderboardProps {
  currentUserId: number
  teamRounds: TeamRound[]
  roundId: number
  leagueId: number
}

export default function IndividualLeaderboard({
  currentUserId,
  teamRounds,
  roundId,
  leagueId
}: IndividualLeaderboardProps) {
  const players = []
  const teamComplete = {}
  for (const tr of teamRounds) {
    for (const p of tr.players) {
      if (!p.canceled) {
        players.push(p)
        teamComplete[p.id] = tr.complete
      }
    }
  }
  players.sort((a, b) => {
    if (a.position.rank < b.position.rank) {
      return -1
    } else if (a.position.rank > b.position.rank) {
      return 1
    } else {
      return a.holesCompleted < b.holesCompleted ? -1 : 1
    }
  })

  const backPath = `${window.location.pathname}${window.location.search}`

  function goToPlayerProfile(sqid: string) {
    window.location.href = appPlayerProfilePath(sqid, {
      back_path: backPath,
      round_id: roundId,
      league_id: leagueId
    })
  }

  return (
    <table className="round-scoring-leaderboard" style={{ marginBottom: "2rem" }}>
      <thead>
        <tr>
          <th></th>
          <th>PLAYER</th>
          <th className="round-scoring-value">SCORE</th>
          <th className="round-scoring-value">THRU</th>
          <th className="round-scoring-value">PTS</th>
        </tr>
      </thead>
      <tbody>
        {players.map((p, i) => {
          return (
            <Fragment key={i}>
              <tr
                className="team"
                style={{
                  cursor: p.user.sqid ? "pointer" : "default",
                  fontWeight: currentUserId && p.user.id === currentUserId ? "bold" : "normal"
                }}
                onClick={() => {
                  if (p.user.sqid) goToPlayerProfile(p.user.sqid)
                }}
              >
                <td style={{ minWidth: "26px" }}>{p.position.label}</td>
                <td className="team-name">{p.user.name}</td>
                <td className="round-scoring-value">{p.holesCompleted ? formatScore(p.netScoreRelativeToPar) : ""}</td>
                <td className="round-scoring-value">{thru(p.holesCompleted, teamComplete[p.id])}</td>
                <td className="round-scoring-value">{p.holesCompleted ? p.position.points : ""}</td>
              </tr>
            </Fragment>
          )
        })}
      </tbody>
    </table>
  )
}
